import type { EncodedRoutePath } from '@jotta/utils/path/EncodedRoutePath'
import { forwardRef } from 'react'
import type { LinkProps, NavLinkProps } from 'react-router-dom'
import { Link, NavLink } from 'react-router-dom'

export type EncodedRouteLinkOwnProps = {
  to: EncodedRoutePath
}
export type EncodedRouteLinkProps<
  T extends NavLinkProps | LinkProps = LinkProps,
> = EncodedRouteLinkOwnProps & Omit<T, 'to'>
/**
 * Create a link from a partial Route object, preserves the current route context
 * (context, viewmode and sortby) unless you specifically override with your own values
 *
 * If you don't pass any props it will just link to the current route
 *
 * Extends the React Router Link component, and all of its props are valid except "to"
 *
 * @param props
 * @returns
 */
export const EncodedRouteLink = forwardRef<
  HTMLAnchorElement,
  EncodedRouteLinkProps
>(function EncodedRouteLink({ to, ...props }, ref) {
  return <Link to={to.encodedPath} {...props} ref={ref} />
})

/**
 * Create a link from a partial Route object, preserves the current route context
 * (context, viewmode and sortby) unless you specifically override with your own values
 *
 * If you don't pass any props it will just link to the current route
 *
 * Extends the React Router NavLink component, and all of its props are valid except
 * "to"
 */
export const EncodedRouteNavLink = forwardRef<
  HTMLAnchorElement,
  EncodedRouteLinkProps<NavLinkProps>
>(function EncodedRouteLink({ to, ...props }, ref) {
  return <NavLink to={to.encodedPath} {...props} ref={ref} />
})
